import { Component, ElementRef, OnInit, Renderer, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../api/services/project.services';

@Component({
  selector: 'app-bpa-upload',
  templateUrl: './bpa-upload.component.html',
  styleUrls: ['./bpa-upload.component.scss']
})
export class BpaUploadComponent implements OnInit {

  @ViewChild('downloadAnchor') anchor: ElementRef;

  atcType: string = "Tower";
  hasFile = false;
  fileId: string;
  errorCreatingByFile = false;
  errorMessage: string[] = [];
  isShown: boolean = true ;
  blob: any;
  disableImportButton: boolean = false;
  loading: boolean = false;
  atcTypes: string[] = []; 

  constructor(
    public projectService: ProjectService,
    private renderer: Renderer,
    private toastr: ToastrService
  ) { }

  ngOnInit() { 
    this.atcTypes = ['Tower'];
  }

  setATCType(atcType: string) {
    this.errorCreatingByFile = false;
    this.hasFile = false;
    this.isShown = true;
    this.atcType = atcType;
    // Set the atcTypes array based on the condition or data source
    if (atcType === 'Tower') {
      this.atcTypes = ['Tower'];
    } else if (atcType === 'DAS') {
      this.atcTypes = ['DAS'];
    } else if (atcType === 'Steel') {
      this.atcTypes = ['Steel'];
    }
  }

  onImportFileUploaded(id: string) {
    this.hasFile = true;
    this.fileId = id;
    this.projectService.uploadBPAFile(this.fileId, this.atcType).subscribe(() => {
      this.hasFile = false;
      this.onUploadSuccess("BPA Upload");
    }, error => {
      this.errorCreatingByFile = true;
      this.isShown = !this.isShown;
      this.errorMessage.push(error.error.message);
    });
  }

  private onUploadSuccess(message: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  downloadExistingBPAData(atcType) {
    this.loading = true;
    this.disableImportButton = true;
    this.projectService.downloadBPAData(atcType).subscribe((resp) => {
      const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : atcType + '_BPA_' + new Date();
      const data = resp.body;
      this.blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName + '.xlsx';
      link.click();
      this.loading = false;
      this.disableImportButton = false;
    }, error => {
      this.onError(error.error.message);
      this.loading = false;
      this.disableImportButton = false;
    });
  }


  private onError(msg: string) {
    this.toastr.error(msg, 'Error!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  downloadTemplate() {
    this.renderer.invokeElementMethod(this.anchor.nativeElement, 'click', []);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bpa-upload/bpa-upload.component.ts